import { useEffect, useState } from "react";
import { TagsContentsView } from "../components/TagsContentView";
import { SingleInputModal } from "../components/SingleInputModal";
import * as bootstrap from 'bootstrap';
import { createNewTag, get_tags_list, deleteTag, get_tag_list_of_mapped_videos } from "../assets/constants/global_apis";
import { ConfirmationModal } from "../components/ConfirmationModal";
import SearchMenu from "../components/SearchMenu";

export default function Tags() {
  const [tags, setTags] = useState([]);
  const [selected_tag, setSelectedTag] = useState({});
  const [showTagView, setShowTagView] = useState(false);
  const [deleteTagId, setDeleteTagId] = useState(-1)
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [request, setRequest] = useState({
    label: ""
  });
  const [buttonAction, setbuttonAction] = useState({
    event: '',
    eventMessage: ''
  })

  const [open, setOpen] = useState(false);


  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setbuttonAction({
      event: '',
      eventMessage: ''
    });
    setOpen(false);
  };

  // const collectionId = useSelector(state => state.collections.collectionId);

  const closeModal = () => {
    var myModalEl = document.getElementById('createCollectionModal');
    var modal = bootstrap.Modal.getInstance(myModalEl)
    modal.hide();
  }
  const create_new_tag = (event) => {
    event.preventDefault();
    createNewTag(request).then(data => {
      closeModal();
      setRequest({
        label: ""
      });
      geAlltagsList(); // geAlltagsList();
    })
  }
  const geAlltagsList = () => {
    get_tags_list()
      .then(data => {
        setTags(data);
      })
  }


  const handleDeleteTag = (event, tagName, tagId) => {
    setDeleteTagId(tagId)
    setbuttonAction({
      event: "Delete",
      eventMessage: <span>Are you sure you want to delete <b>{tagName}</b>?</span>
    });
    handleOpen();
  }
  const handleDeleteSubmitConfirmation = () => {
    deleteTag(deleteTagId)
      .then(data => {
        if (deleteTagId == selected_tag.id) {
          setSelectedTag({});
        }
        setDeleteTagId(-1)
        geAlltagsList();
        handleClose();
      })
  }

  const filterTags = (e) => {
    if (e.target.value !== "") {
      let filteredTags = tags.filter((tag) => tag.label.toLowerCase().includes(e.target.value.toLowerCase()));
      setTags(filteredTags);
    } else {
      geAlltagsList();
    }
  }
  useEffect(() => {
    geAlltagsList();
  }, [])
  const handleGetTagVideos = (tag, index) => {
    get_tag_list_of_mapped_videos(tag.id).then((data) => {
      setSelectedTag(tag);
    })
  }

  const handleTagClick = (element, index) => {
    handleGetTagVideos(element, index);
    setSelectedTag(element);
    setShowTagView(true)
  }

  return (
    <div className="container-fluid g-2">
      <div className="row g-2">
        <SearchMenu
          filterFunction={filterTags}
          ElementList={tags}
          handleOnClickItem={handleTagClick}
          handleDelete={handleDeleteTag}
          selectedItem={selected_tag}
          buttonAction='Create'
          title="Tag"
        />
        <div className="col-md-9">
          {showTagView && <TagsContentsView selectedtagId={selected_tag.id} isSidebarOpen={isSidebarOpen} setIsSidebarOpen={setIsSidebarOpen} />}

          <SingleInputModal requestpayload={request} setRequestPayload={setRequest} handleSubmit={create_new_tag} handleClose={closeModal} popupType={'Tag'} />
        </div>
        <ConfirmationModal isThisCenterAligned={true} buttonAction={buttonAction} open={open} handleClose={handleClose} handleSubmitConfirmation={handleDeleteSubmitConfirmation} />
      </div>
    </div>
  );
};
